// hooks/useCustomRouteMatch.js
import { useLocation } from 'react-router-dom';

function useCustomRouteMatch(paths) {
  let { pathname } = useLocation();
  return paths.some(path => pathname === path);
}

export default useCustomRouteMatch;
